/* eslint-disable @typescript-eslint/no-explicit-any */
// Ported from https://github.com/treyhuffine/is-react to ensure we are using the same react version as a dependency
import React from 'react'

const FUNCTION_REGEX = /react(\d+)?./i

function classComponent(component: any): component is React.ReactNode {
  return (
    typeof component === 'function' &&
    component.prototype &&
    !!component.prototype.isReactComponent
  )
}

// Ensure compatibility with transformed code
function functionComponent(component: any): component is React.ReactNode {
  return (
    typeof component === 'function' &&
    String(component).includes('return') &&
    !!String(component).match(FUNCTION_REGEX) &&
    String(component).includes('.createElement')
  )
}

function component(component: any): component is React.ReactNode {
  return classComponent(component) || functionComponent(component)
}

function element(typeElement: any): typeElement is React.ReactElement {
  return React.isValidElement(typeElement)
}

function DOMTypeElement(typeElement: any): typeElement is React.ReactElement {
  return element(typeElement) && typeof typeElement.type === 'string'
}

function compositeTypeElement(
  typeElement: any
): typeElement is React.ReactElement {
  return element(typeElement) && typeof typeElement.type === 'function'
}

function compatible(item: any): item is React.ReactNode {
  return element(item) || component(item)
}

export default {
  classComponent,
  functionComponent,
  component,
  element,
  DOMTypeElement,
  compositeTypeElement,
  compatible,
  toString
}
